module.exports = __webpack_public_path__ + "static/media/plane_clouds.22832134.gif";